/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useContext, useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, useCheckSubmissionVMDirty, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierPL-react/config/PremierPL-wizard-config.json5";
import metadata from './ITProfessionalPage.metadata.json5';
import messages from './ITProfessionalPage.messages';
import styles from './ITProfessionalPage.module.scss';

import CoveragesPageComponent from "../Coverages/CoveragesPage";
import BusinessOperationComponent from "../../components/ITProfessional/BusinessOperation/BusinessOperationComponent"
import CyberLiabilityComponent from "../../components/ITProfessional/CyberLiability/CyberLiabilityComponent"
import IntellectualPropertyComponent from "../../components/ITProfessional/IntellectualProperty/IntellectualPropertyComponent"
import CurrentProjectsComponent from "../../components/ITProfessional/Prior/CurrentProjects/Prior/CurrentProjectsComponent"
import ProductCoverageSelection from "../../components/ITProfessional/ProductCoverageSelection/ProductCoverageSelectionComponent"
import RevenuesComponent from "../../components/ITProfessional/Revenues/RevenuesComponent"
import ScopeofServicesComponent from "../../components/ITProfessional/ScopeofServices/ScopeofServicesComponent"
import SubContractorsComponent from "../../components/ITProfessional/SubContractors/SubContractorsComponent"


function ITProfessionalPage(props) {
    const {
        showConfirm
    } = useModal();

    const { wizardData: submissionVM, updateWizardData, currentStep, history, changeNextSteps, steps } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useTranslator();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { updateSubmission } = useUpdateSubmissionServices();
    const jobNumber = submissionVM.value?.quoteID || submissionVM.value?.jobID;
    const { isDirty } = useCheckSubmissionVMDirty(submissionVM.value);
    const { lineName,jobTypes } = PremierConstants;
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property'))

    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation,
        isComponentValid
    } = useValidation('ITProfessionalPage');

    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {

            const {jobType} = submissionVM.value.baseData;

            if (!_.isUndefined(submissionVM.value.lobData.proLine.coverables.itprofessionalsCoverable.productCoverageSelection.pro6)
                && submissionVM.value.lobData.proLine.coverables.itprofessionalsCoverable.productCoverageSelection.pro6) {
                if (_.filter(steps, (step) => step.id.includes('property')).length === 0) {
                    steps.splice(5, 0, propertySteps[0], propertySteps[1]);
                    changeNextSteps(steps.slice(4, 13))
                }
            } else {
                // eslint-disable-next-line no-lonely-if
                if (_.filter(steps, (step) => step.id.includes('property')).length !== 0) {

                    const startStep = jobType === jobTypes.policyChange ? _.find(steps, (step) => step.id.includes('locations')) >= 0 ? 4 : 3 : 4;

                    changeNextSteps(_.filter(steps, (step) => !step.id.includes('property')).slice(startStep, 12))
                }
            }

            const {productCode} = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', submissionVM);

            return submissionVM;
        },
        [submissionVM, updateSubmission]
    );

    const overrideProps = {
        businessOperationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.itprofessionalsCoverable.businessOperation"
        },
        cyberLiabilityComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.itprofessionalsCoverable.cyberLiability"
        },
        priorComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.itprofessionalsCoverable.currentProjects"
        },
        productCoverageSelection: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.itprofessionalsCoverable.productCoverageSelection"
        },
        revenueComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.itprofessionalsCoverable.revenues"
        },
        scopeofServicesComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.itprofessionalsCoverable.scopeofServices"
        },
        subContractorsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            visible: !_.isUndefined(submissionVM.lobData.value.proLine.coverables.itprofessionalsCoverable.productCoverageSelection.doeTheAppSubAnyWorTo9) && submissionVM.lobData.value.proLine.coverables.itprofessionalsCoverable.productCoverageSelection.doeTheAppSubAnyWorTo9,
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.itprofessionalsCoverable.subContractors"
        },
        intellectualPropertyComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            visible: !_.isUndefined(submissionVM.lobData.value.proLine.coverables.itprofessionalsCoverable.productCoverageSelection.doYouReqInsForIntPro10) && submissionVM.lobData.value.proLine.coverables.itprofessionalsCoverable.productCoverageSelection.doYouReqInsForIntPro10,
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.itprofessionalsCoverable.intellectualProperty"
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            businessOperationComponent: BusinessOperationComponent,
            cyberLiabilityComponent: CyberLiabilityComponent,
            intellectualPropertyComponent: IntellectualPropertyComponent,
            priorComponent: CurrentProjectsComponent,
            productCoverageSelection: ProductCoverageSelection,
            revenueComponent: RevenuesComponent,
            scopeofServicesComponent: ScopeofServicesComponent,
            subContractorsComponent: SubContractorsComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );


    const isDisableNext = () => !submissionVM.lobData.proLine.coverables.itprofessionalsCoverable.aspects.subtreeValid

    const onSave = useCallback(
            async () => {
                const subVMCopy = _.clone(submissionVM)
                const productCode = _.get(subVMCopy.value, 'baseData.productCode');
    
                validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.proLine.coverables.itprofessionalsCoverable.value, ' ')
    
                const lobLineName = productCode ? lineName[productCode] : '';

                await updateSubmission(lobLineName, 'ITProfessionalPage', subVMCopy);
                
                return submissionVM;
            },
            [submissionVM]
        );

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

ITProfessionalPage.propTypes = wizardProps;
export default withRouter(ITProfessionalPage);
